<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div class="alert alert-info" role="alert">
                <h5>{{ $t('localization.help')}}</h5>
            </div>

            <div class="row sticky-top ml-3 mr-3" style="background-color:white">
                <div class="col-md-12 col-lg-6">
                    <div class="form-group ">
                        <textarea v-model="model.bgContent"
                                  rows="20"
                                  class="form-control"
                                  style="width:100%; background-color:whitesmoke">
                        </textarea>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6">
                    <div class="form-group">
                        <textarea v-model="model.enContent"
                                  rows="20"
                                  class="form-control"
                                  style="width:100%; background-color:whitesmoke">
                        </textarea>
                    </div>
                </div>
                <div class="btn-group form-group">
                    <button type="button" class="btn btn-primary"
                            v-bind:disabled="saving"
                            @click.stop="loadLangContent">
                        <i class="fas fa-sync-alt mr-2"></i>{{ $t('buttons.reload.btnText')}}
                    </button>
                    <button type="button" class="btn btn-primary"
                            v-bind:disabled="saving"
                            @click.stop="saveLangContent">
                        <i class="far fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}
                    </button>
                </div>
            </div>
            <hr />

            <div class="row">
                <div class="col-md-12 col-lg-6">
                    <div v-if="model.bgContent">
                        <vue-json-pretty :data="bgContentObject"
                                         :showLine="true"
                                         :highlightMouseoverNode="true"
                                         :showDoubleQuotes="false"
                                         :showLength="true"
                                         @click="bgContentClick">
                        </vue-json-pretty>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div v-if="model.enContent">
                        <vue-json-pretty :data="enContentObject"
                                         :showLine="true"
                                         :highlightMouseoverNode="true"
                                         :showDoubleQuotes="false"
                                         :showLength="true"
                                         @click="enContentClick">
                        </vue-json-pretty>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import VueJsonPretty from 'vue-json-pretty'
    import langService from '../../services/lang.service';
    import { LocalizationFilesModel } from '../../models/models';
    import { mapGetters } from 'vuex'

    export default {
        props: {
        },
        components: {
            VueJsonPretty
        },
        data() {
            return {
                loading: false,
                saving: false,
                model: new LocalizationFilesModel({merge: false}),
            };
        },
        methods: {
            loadLangContent() {
                this.loading = true;

                langService
                    .getLanguagesContents()
                    .then(response => {
                        if (response.data) {
                            this.model.bgContent = response.data.bgContent;
                            this.model.enContent = response.data.enContent;
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.loading = false }

                    );
            },
            validateJsonObjects() {
                let isValid = true;

                try {
                    JSON.parse(this.model.bgContent);
                } catch (e) {
                    isValid = false;

                    this.$vs.notify({
                        title: this.$t('localization.bgTitle'),
                        text: this.$t('localization.bgJsonSchemaError'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })
                }

                try {
                    JSON.parse(this.model.enContent);
                } catch (e) {
                    isValid = false;

                    this.$vs.notify({
                        title: this.$t('localization.enTitle'),
                        text: this.$t('localization.enJsonSchemaError'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })
                }

                return isValid;
            },
            saveLangContent() {
                this.saving = true;

                if (!this.validateJsonObjects()) {
                    return;
                }

                langService
                    .saveJsLocalizationFiles(this.model)
                    .then(response => {
                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.saving = false }

                    );

            },
            bgContentClick(path, data) {
            },
            enContentClick(path, data) {

            }
        },
        created() {
            this.loadLangContent();
        },
        computed: {
            ...mapGetters(['claims']),
            bgContentObject() {
                if (!this.model.bgContent) {
                    return {};
                }

                return JSON.parse(this.model.bgContent);
            },
            enContentObject() {
                if (!this.model.enContent) {
                    return {};
                }

                return JSON.parse(this.model.enContent);
            }
        }
    }
</script>

<style scoped>
</style>
